<template>
  <div class="chart-page">
    <div class="list-toolbar">
      <el-input
        v-model="filter"
        size="small"
        prefix-icon="el-icon-search"
        placeholder="Filter by pod ID"
        style="width: 220px"
        clearable
      />
      <div class="toolbar-right">
        <span class="record-count">{{ tableData.length }} pods</span>
        <el-button
          v-if="p('Pods.Calibration.Add')"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="add()"
        >
          {{ $t('text.add') | firstLetterCapitalize }}
        </el-button>
      </div>
    </div>

    <el-table
      border
      ref="table"
      :data="tableData"
      size="small"
      v-loading="loading"
      :max-height="tableHeight"
      class="app-table"
    >
      <el-table-column :label="$t('text.pod') + ' ID'" prop="podId" />
      <el-table-column :label="$t('text.calibrattion_status')">
        <template slot-scope="scope">
          <div>{{ $t('text.capacitive') }}: {{ scope.row.capactive_cal }}</div>
          <div>
            {{ $t('text.accelerometer') }}: {{ scope.row.accelerometer_cal }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="$t('text.action') | firstLetterCapitalize"
        width="120"
        v-if="p('Pods.Calibration.Edit')"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" plain @click="edit(scope.row)">
            {{ $t('text.view') | firstLetterCapitalize }}/{{
              $t('text.edit') | firstLetterCapitalize
            }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <EditCalibration ref="editCalibration" />
  </div>
</template>

<script>
import EditCalibration from '@/components/pods/calibration/EditCalibration'
import ApiService from '@/services/CommonApiService.js'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      filter: '',
      timer: '',
      tableHeight: 0
    }
  },
  components: {
    EditCalibration
  },
  mounted() {
    this.getData()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 50
      const self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 50
      }
    })
  },
  watch: {
    filter() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.GetPodCharacteristics()
        .then(response => {
          this.loading = false
          const vm = this
          this.tableData = response.data.data.filter(
            item =>
              item.podId.toLowerCase().indexOf(vm.filter.toLowerCase()) > -1
          )
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.editCalibration.openDialog()
    },
    edit(row) {
      this.$refs.editCalibration.openDialog()
      this.$refs.editCalibration.form = JSON.parse(JSON.stringify(row))
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.cal-badge {
  display: inline-block;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;

  &.cal-filled {
    background: #f0f9eb;
    color: #67c23a;
    border: 1px solid #c2e7b0;
  }

  &.cal-empty {
    color: #c0c4cc;
  }
}
</style>
